import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NoticiaModel } from 'src/app/models/noticia.model';
import { SeoService } from 'src/app/services/seo.service';
import { AsociacionService } from '../../services/asociacion.service';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.scss'],
})
export class NoticiasComponent extends SeoService implements OnInit {
  public pageTitle: 'Prensa' | 'Conversatorios';
  public registros$: Observable<NoticiaModel[]>;
  
  private currentPath: string;
  private routeSnapshot: ActivatedRouteSnapshot;

  public noticias: any[] = [];
  public loading: boolean = false;

  constructor(
    private _asociacionService: AsociacionService,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {
    super(titleService, metaService);
    this.routeSnapshot = this.route.snapshot;
  }

  get RouteToDirect() {
    return this.pageTitle === 'Conversatorios' ? '/conversatorios/' : '/noticia/noticia/';
  }

  ngOnInit() {
    this.pageTitle = this.routeSnapshot.data['section'];

    this.updateTags(this.pageTitle, this.currentPath);

    this.registros$ = this.pageTitle === 'Conversatorios' ? 
                        this._asociacionService.getAllConversatorios() : 
                        this._asociacionService.getAllNoticias().pipe(map(res => res.data));
  }
}
